export const TEACHER_CERTIFICATE_SLUG = 'base';
